import { DeviceType } from '@/shared/types';
import { fetch, Key } from '@maxtropy/components';
import { PageRequest, PageResponse } from './page';

// 环保设备树接口
export interface DeviceTypeTree {
  aliasName: string[];
  tree: DeviceType[];
}

export const getEnvDeviceTree = () =>
  fetch<DeviceTypeTree>(
    '/api/v2/energy/overview/tree',
    {
      method: 'POST',
      body: JSON.stringify({}),
    },
    true
  );

// 获取设备数据属性（复用scada接口）
export interface EnvDataProperty {
  dataPropertyId: number;
  dataPropertyName: string;
  dataPropertyType: number;
  measurementType: number; // 累积量或瞬时量
}

// 维度类型枚举 - 使用字符串匹配后端返回值
export enum DimensionType {
  ORIGINAL = 'ORIGINAL', // 原始数据
  ONE_MINUTE = '1M', // 1分钟
  FIFTEEN_MINUTE = '15M', // 15分钟
  THIRTY_MINUTE = '30M', // 30分钟
  HOUR = 'H', // 小时
  DAY = 'D', // 日
}

export const DimensionTypeDisplay: Record<string, string> = {
  [DimensionType.ORIGINAL]: '原始数据',
  [DimensionType.ONE_MINUTE]: '1分钟',
  [DimensionType.FIFTEEN_MINUTE]: '15分钟',
  [DimensionType.THIRTY_MINUTE]: '30分钟',
  [DimensionType.HOUR]: '小时',
  [DimensionType.DAY]: '日',
};

// 根据measurementType判断是累积量还是瞬时量
// 累积量(1): 只有日
// 瞬时量(0): 原始数据, 1分钟, 15分钟, 30分钟, 小时, 日
export const getDimensionOptions = (measurementType: number) => {
  if (measurementType === 1) {
    // 累积量，只有日
    return [{ label: '日', value: DimensionType.DAY }];
  } else {
    // 瞬时量，有原始数据, 1分钟, 15分钟, 30分钟, 小时, 日
    return [
      { label: '原始数据', value: DimensionType.ORIGINAL },
      { label: '1分钟', value: DimensionType.ONE_MINUTE },
      { label: '15分钟', value: DimensionType.FIFTEEN_MINUTE },
      { label: '30分钟', value: DimensionType.THIRTY_MINUTE },
      { label: '小时', value: DimensionType.HOUR },
      { label: '日', value: DimensionType.DAY },
    ];
  }
};
